import { Button } from "@finanedi.es/storybook"
import Avatar from "common/components/Avatar"
import { useTranslation } from "react-i18next"

// TODO: Endpoint listado de empresas
const EmpresaCard = ({
  empresa,
  empresaActivaId,
  handleCambiarEmpresaActiva,
  isCambiandoEmpresaActiva,
  handleEmpresaAvalidar,
}: $TSMigrationFixMe) => {
  const selectedCompany = Boolean(empresaActivaId === empresa?.id)
  const { t } = useTranslation()

  return (
    <div
      className={`tw-bg-simple-10 tw-w-full tw-h-auto tw-px-4 tw-py-3 tw-flex tw-items-center tw-justify-between tw-rounded hover:tw-shadow ${
        selectedCompany &&
        "tw-border-solid tw-border-2 tw-border-secondary hover:tw-shadow-none"
      } ${isCambiandoEmpresaActiva && "tw-pointer-events-none tw-opacity-40"}`}
    >
      <div
        className='tw-flex tw-flex-row tw-items-center tw-cursor-pointer tw-w-full'
        onClick={() =>
          empresaActivaId !== empresa?.id &&
          handleCambiarEmpresaActiva(empresa.id)
        }
      >
        <Avatar
          logo={empresa?.logoAsBase64}
          initials={empresa?.razonSocial.slice(0, 2).toUpperCase()}
          size='tw-w-14 tw-h-14'
          // @ts-expect-error TS(2322): Type '{ logo: $TSFixMe; initials: $TSFixMe; size: string; fo...
          fontSize='tw-text-xl'
        />
        <div className='tw-flex-col tw-text-left tw-pr-4'>
          <p
            className={`tw-pl-3 tw-mb-1 tw-h-[19px] tw-max-w-60 ${
              selectedCompany && "tw-font-medium"
            } sm:tw-max-w-96 lg:tw-max-w-60 xl:tw-max-w-48 tw-truncate tw-flex-shrink`}
          >
            {empresa?.razonSocial}
          </p>
          <p className='tw-pl-3 tw-mb-0 tw-text-info-100 tw-text-sm'>
            {empresa?.nif}
          </p>
        </div>
      </div>
      <div>
        {empresa?.verificada ? (
          <p className='tw-bg-success tw-text-white tw-px-2 tw-py-1 tw-rounded-sm tw-mb-0 tw-font-medium tw-text-xs'>
            {t("seleccionDeEmpresa.validated")}
          </p>
        ) : (
          <Button
            type='text'
            className='!tw-border-solid !tw-border-primary !tw-px-2 !tw-py-1 tw-h-6 tw-w-[63px] tw-bg-white tw-text-primary hover:!tw-bg-primary hover:!tw-text-white !tw-rounded-sm tw-font-medium tw-text-xs !tw-leading-3'
            onClick={(e) => handleEmpresaAvalidar(e, empresa)}
          >
            {t("seleccionDeEmpresa.validate")}
          </Button>
        )}
      </div>
    </div>
  )
}

export default EmpresaCard
